<template>
  <div class="prizes-page prizes-alternating-layout">
    <!-- Header/Hero is rendered globally, so we jump straight to the content -->
    <section class="what-you-win-section py-5">
      <div class="container py-4">
        <h2 class="section-title text-center mb-5" v-html="$t('Prizes.SectionTitle')">
        </h2>
      </div>

      <!-- Row 1: Premium Headphones -->
      <div class="alternating-row bg-white py-5">
        <div class="container">
          <div class="row align-items-center">
            <!-- Left: Triangles & Text -->
            <div class="col-lg-6 col-12 d-flex align-items-start order-2 order-lg-1 px-4 px-lg-3">
              <!-- Triangles column (desktop only, shown on the side) -->
              <div class="triangles-wrapper me-4 d-none d-md-block">
                <svg class="triangle-grid" width="48" height="240" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <defs>
                    <pattern id="tri-pat-right" x="0" y="0" width="16" height="20" patternUnits="userSpaceOnUse">
                      <polygon points="2,5 8,9 2,13" fill="#2584C5" opacity="0.18" />
                    </pattern>
                  </defs>
                  <rect width="100%" height="100%" fill="url(#tri-pat-right)" />
                </svg>
              </div>
              
              <!-- Text content -->
              <div class="prize-content-text py-2">
                <h3 class="prize-title">{{ $t('Prizes.WinHeadphones') }}</h3>
                <p class="prize-desc">
                  {{ $t('Prizes.HeadphonesDesc') }}
                </p>
              </div>
            </div>

            <!-- Right: Image -->
            <div class="col-lg-6 col-12 text-center order-1 order-lg-2 mb-4 mb-lg-0 px-4 px-lg-3">
              <div class="prize-img-frame">
                <img src="/assets/images/headfhone1.png" alt="Win Premium Headphones" class="img-fluid alternating-img" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Row 2: Travel -->
      <div class="alternating-row bg-light-row py-5">
        <div class="container">
          <div class="row align-items-center">
            <!-- Left: Image -->
            <div class="col-lg-6 col-12 text-center order-1 mb-4 mb-lg-0 px-4 px-lg-3">
              <div class="prize-img-frame">
                <img src="/assets/images/plane1.png" alt="Win a chance to travel" class="img-fluid alternating-img" />
              </div>
            </div>

            <!-- Right: Text & Triangles -->
            <div class="col-lg-6 col-12 d-flex align-items-start order-2 px-4 px-lg-3">
              <!-- Text content -->
              <div class="prize-content-text py-2">
                <h3 class="prize-title">{{ $t('Prizes.WinTravel') }}</h3>
                <p class="prize-desc">
                  {{ $t('Prizes.TravelDesc') }}
                </p>
              </div>

              <!-- Triangles column (desktop only, shown on the right) -->
              <div class="triangles-wrapper ms-4 d-none d-md-block">
                <svg class="triangle-grid" width="48" height="240" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="100%" height="100%" fill="url(#tri-pat-right)" />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Row 3: Accessories -->
      <div class="alternating-row bg-white py-5">
        <div class="container">
          <div class="row align-items-center">
            <!-- Left: Triangles & Text -->
            <div class="col-lg-6 col-12 d-flex align-items-start order-2 order-lg-1 px-4 px-lg-3">
              <!-- Triangles column -->
              <div class="triangles-wrapper me-4 d-none d-md-block">
                <svg class="triangle-grid" width="48" height="240" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="100%" height="100%" fill="url(#tri-pat-right)" />
                </svg>
              </div>
              
              <!-- Text content -->
              <div class="prize-content-text py-2">
                <h3 class="prize-title">{{ $t('Prizes.WinAccessories') }}</h3>
                <p class="prize-desc">
                  {{ $t('Prizes.AccessoriesDesc') }}
                </p>
              </div>
            </div>

            <!-- Right: Image -->
            <div class="col-lg-6 col-12 text-center order-1 order-lg-2 mb-4 mb-lg-0 px-4 px-lg-3">
              <div class="prize-img-frame">
                <img src="/assets/images/accessories1.png" alt="Win Accessories" class="img-fluid alternating-img" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'PrizesAlternating'
};
</script>

<style scoped>
/* Alternating Layout styling */
.prizes-page {
  font-family: 'Roboto', sans-serif;
  background-color: #ffffff;
}

.section-title {
  font-size: 2.25rem;
  font-weight: 700;
  color: #333333;
}

.text-blue {
  color: #2584C5;
}

.alternating-row {
  transition: background-color 0.3s ease;
  overflow: hidden;
}

.bg-light-row {
  background-color: #f8fafc;
}

.triangles-wrapper {
  display: flex;
  align-items: center;
}

.triangle-grid {
  opacity: 0.8;
}

.prize-content-text {
  flex-grow: 1;
  text-align: left;
}

.prize-title {
  font-size: 1.85rem;
  font-weight: 700;
  color: #000000;
  margin-bottom: 1.25rem;
  line-height: 1.2;
}

.prize-desc {
  font-size: 1.05rem;
  line-height: 1.6;
  color: #555555;
  margin-bottom: 0;
}

.prize-img-frame {
  display: inline-block;
  max-width: 100%;
}

.alternating-img {
  max-width: 100%;
  height: auto;
  transition: transform 0.5s ease;
}

.alternating-row:hover .alternating-img {
  transform: scale(1.02);
}

/* FPO Terms */
.fpo-terms-text {
  font-size: 0.8rem;
  line-height: 1.6;
  color: #666666;
  max-width: 900px;
}

/* Responsive Overrides */
@media (max-width: 991px) {
  .section-title {
    font-size: 1.85rem;
    margin-bottom: 2rem !important;
  }
  .prize-title {
    font-size: 1.5rem;
    margin-bottom: 0.75rem;
  }
  .prize-desc {
    font-size: 0.95rem;
    line-height: 1.5;
  }
  .alternating-row {
    padding: 3rem 0 !important;
  }
}

@media (max-width: 767px) {
  .prize-content-text {
    text-align: center;
  }
  .triangles-wrapper {
    display: none !important;
  }
  .alternating-row {
    padding: 2.5rem 0 !important;
  }
}
</style>
